import { render, staticRenderFns } from "./LAnimate.vue?vue&type=template&id=907a338a&scoped=true&"
import script from "./LAnimate.vue?vue&type=script&lang=js&"
export * from "./LAnimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907a338a",
  null
  
)

export default component.exports